import * as React from 'react';

import { mapDispatchToActions } from '@/utils/store';

import actionCreators from './action-creators';
import reducer, { initialState } from './reducer';

/* NOTE: Can genericize further, factory to create a store. */

const inputStore = React.createContext<{
  state: typeof initialState;
  actions: Record<keyof typeof actionCreators, any>;
}>({
  state: initialState,
  actions: actionCreators,
});

const { Provider } = inputStore;

const StateProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const actions = mapDispatchToActions(dispatch, actionCreators);

  return <Provider value={{ state, actions }}>{children}</Provider>;
};

export { StateProvider as default, inputStore };
